export const getLastLogin = () => {
  const lastLogin = localStorage.getItem('last-login')
  return lastLogin ? JSON.parse(lastLogin) : { type: 'none' }
}
